export default "fragment PasswordHelpMessagesConfig on ValidationRule_v2{... on ValidationRulePattern{regex:value message:successMessage}}"